// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"a16b3287","150":"5d3a4899","174":"5e8843b7","310":"b170a5c1","351":"04bdc4f3","371":"64857e74","559":"f97b9136","626":"21da22d3","819":"92145baf","853":"12352f99"}[chunkId] + ".chunk.js";
};